import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Item } from '@shared/interfaces';
import { fetchItemsThunk } from '../actions/itemsActions';

// First, create the entity adapter
export const itemsAdapter = createEntityAdapter<Item, string>({
  selectId: (item: Item) => item.id,
});

// Then, define the initial state using the adapter's getInitialState method
const initialState = itemsAdapter.getInitialState<{
  loading: 'idle' | 'loading';
  query: string;
  error: string | null;
}>({
  loading: 'idle',
  query: '',
  error: null,
});

// Then, create the slice
const itemsSlice = createSlice({
  name: 'items',
  initialState,
  reducers: {
    resetItems: state => {
      state.loading = 'idle';
      state.query = '';
      state.error = null;
      itemsAdapter.removeAll(state);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setQuery: (state, action) => {
      state.query = action.payload;
    },
    // Add more reducers here
  },
  extraReducers: builder => {
    builder.addCase(fetchItemsThunk.pending, state => {
      state.loading = 'loading';
    });
    builder.addCase(fetchItemsThunk.fulfilled, (state, action) => {
      state.loading = 'idle';
      itemsAdapter.setAll(state, action.payload);

      if (action.payload.length === 0) {
        state.error = 'No results found';
      }
    });
    builder.addCase(fetchItemsThunk.rejected, (state, action) => {
      state.loading = 'idle';
      state.error = action.error.message || null;
    });
  },
});

// Export the generated reducer
export const itemsReducer = itemsSlice.reducer;

export const { resetItems, setQuery } = itemsSlice.actions;
